export const ATS_EXPORTS = {
    ATS_TEMPLATE_LIST_PAGE: "ats-template-list-page",
    ATS_TEMPLATE_LIST_PAGE_BREADCRUMB: "ats-template-list-page-breadcrumb",
    CREATE_NEW_BUTTON: "create-new-button",
};
